import Swiper from "swiper";

window.addEventListener("load", function () {
  const $galleries = $(".bm-article-gallery.swiper");
  if ($galleries.length) {
    window.swiperArticles = [];
    $galleries.each((i, el) => {
      const $el = $(el);
      const $wrapper = $el.closest(".bm-article-gallery__wrap");
      const nextEl = $wrapper.find(
        ".bm-article-gallery__pagination-btn__next"
      )[0];
      const prevEl = $wrapper.find(
        ".bm-article-gallery__pagination-btn__prev"
      )[0];
      const swiper = new Swiper(el, {
        // spaceBetween: 32,
        speed: 1500,
        slidesPerView: 1,
        freeMode: true,
        // slidesOffsetBefore: 30,
        // slidesOffsetAfter: 50,
        watchSlidesProgress: true,

        // pagination: true,
        // pagination: {
        //   el: $wrapper.find(".swiper-pagination")[0],
        //   type: "fraction",
        //   clickable: true,
        //   renderFraction: function (currentClass, totalClass) {
        //     return (
        //       '<span class="' +
        //       currentClass +
        //       '"></span>' +
        //       " <small>/ " +
        //       '<span class="' +
        //       totalClass +
        //       '"></span></small>'
        //     );
        //   },
        // },

        navigation: {
          nextEl,
          prevEl,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.3,
            spaceBetween: 15,
          },
          480: {
            slidesPerView: 1.7,
            spaceBetween: 15,
          },

          680: {
            slidesPerView: 2.5,
            spaceBetween: 15,
          },

          // 768: {
          // 	slidesPerView: 2.5,
          // 	spaceBetween: 15,
          // },
          950: {
            slidesPerView: 3.45,
            spaceBetween: 15,
          },
        },
        on: {
          afterInit: (self) => {
            $(self.originalParams.navigation.nextEl).on("click", () => {
              self.slideNext();
            });
            $(self.originalParams.navigation.prevEl).on("click", () => {
              self.slidePrev();
            });
          },
        },
      });
      window.swiperArticles.push(swiper);
    });
  }
});
